// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "0.3.31/static/js/" + chunkId + "." + {"110":"b3c41d5b","467":"54974f5f"}[chunkId] + ".chunk.js";
};